/** Cloudflare is currently a static preview, not a public production gateway. */
export const publicPreview = import.meta.env.VITE_PUBLIC_PREVIEW === 'true';
